import { CommonModule } from '@angular/common';
import {
  Component,
  ElementRef,
  EventEmitter,
  Input,
  Output,
  ViewChild
} from '@angular/core';
import { locationMocks } from './mocks/location.mocks';
import { Location } from './models/location.interface';

@Component({
  selector: 'idp-location',
  standalone: true,
  imports: [CommonModule],
  templateUrl: './location.component.html',
  styleUrls: ['./location.component.scss']
})
export class LocationComponent {
  @Input() content: Location = locationMocks;
  @Input() error = '';
  @Output() locationClicked = new EventEmitter<boolean>(false);

  @ViewChild('locationField') locationField!: ElementRef<HTMLElement>;

  focusField(): void {
    const el = this.locationField?.nativeElement;
    if (el) {
      el.focus({ focusVisible: true } as FocusOptions);
    }
  }
}
